// import React, { useContext, useEffect,} from "react";
// import { AdminContext } from "context/AdminContext";
// import { useDispatch } from "react-redux";
// import { emptySetting } from "redux/Actions/SettingActions";
// import { emptySideBarMenu } from "redux/Actions/SideBarActions";

// const InactivityHandler = ({ children }) => {
//     const {  dispatch } = useContext(AdminContext);
//      const reduxDisPatch = useDispatch();
//   const inactivityLimit = 60 *60 * 1000; // 60 minutes
//   const activityKey = "lastActivity"; // Key in localStorage

//   const handleLogOut = () => {
//       dispatch({ type: "USER_LOGOUT" });
//       localStorage.removeItem("adminInfo");
//        localStorage.removeItem("chatId");
//        localStorage.removeItem("agentId");

       

//       localStorage.removeItem(activityKey);
//       sessionStorage.removeItem("isOnline");
//       reduxDisPatch(emptySideBarMenu());
//       reduxDisPatch(emptySetting());
//       // window.location.replace(`http://localhost:4009/login`);
//     };
//   const updateActivity = () => {
//     const timestamp = Date.now();
//     localStorage.setItem(activityKey, timestamp.toString());
//   };

//   const checkInactivity = () => {
//     const lastActivity = localStorage.getItem(activityKey);
//     const now = Date.now();

//     if (lastActivity && now - parseInt(lastActivity) > inactivityLimit) {
//       localStorage.removeItem(activityKey);
//       handleLogOut();
//     }
//   };

//   const resetTimer = () => {
//     updateActivity(); // Update activity on interaction
//   };

//   useEffect(() => {
//     const events = ["mousemove", "click", "keydown", "scroll"];

//     // Set initial activity timestamp
//     updateActivity();

//     // Add event listeners to reset timer
//     events.forEach((event) => window.addEventListener(event, resetTimer));

//     // Periodically check for inactivity
//     const interval = setInterval(checkInactivity, 1000);

//     // Listen for changes in activity from other tabs
//     const handleStorageChange = (e) => {
//       if (e.key === activityKey) {
//         checkInactivity();
//       }
//     };
//     window.addEventListener("storage", handleStorageChange);

//     return () => {
//       clearInterval(interval);
//       events.forEach((event) => window.removeEventListener(event, resetTimer));
//       window.removeEventListener("storage", handleStorageChange);
//     };
//      /* eslint-disable-next-line react-hooks/exhaustive-deps */
//   }, []);

//   return <>{children}</>;
// };

// export default InactivityHandler;




import React, { useContext, useEffect, useRef } from "react";
import { AdminContext } from "context/AdminContext";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";

import { emptySetting } from "redux/Actions/SettingActions";
import { emptySideBarMenu } from "redux/Actions/SideBarActions";

import socket from "services/SocketService";
import { teardownPushNotifications } from "utils/browserNotify";
import ChatServices from "services/ChatServices";
import { useChatStatus } from "context/ChatStatusContext";

const InactivityHandler = ({ children }) => {
  const { dispatch } = useContext(AdminContext);
  const reduxDisPatch = useDispatch();

  const { isOnline, goOffline } = useChatStatus();

  const inactivityLimit = 60 * 60 * 1000; 
  const activityKey = "lastActivity";

  const logoutInProgress = useRef(false);

  const handleLogOut = async () => {
    if (logoutInProgress.current) return;

    logoutInProgress.current = true;

    try {
      try {
        if (isOnline) {
          await goOffline();
        }
      } catch (error) {
        console.error(
          "Failed to update chat status to offline:",
          error
        );
      }

      try {
        await teardownPushNotifications(
          ChatServices.deletePushSubscription
        );
      } catch (error) {
        console.error(
          "Failed to remove push subscription:",
          error
        );
      }

      dispatch({ type: "USER_LOGOUT" });

      Cookies.remove("adminInfo");
      localStorage.removeItem("adminInfo");
      localStorage.removeItem("chatId");
      localStorage.removeItem("agentId");
      localStorage.removeItem(activityKey);

      sessionStorage.removeItem("isOnline");

      socket.disconnect();

      reduxDisPatch(emptySideBarMenu());
      reduxDisPatch(emptySetting());
    } finally {
      logoutInProgress.current = false;
    }
  };

  const updateActivity = () => {
    localStorage.setItem(activityKey, Date.now().toString());
  };

  const checkInactivity = async () => {
    const lastActivity = localStorage.getItem(activityKey);

    if (!lastActivity) return;

    const now = Date.now();
    const elapsed = now - Number(lastActivity);

    if (elapsed >= inactivityLimit) {
      await handleLogOut();
    }
  };

  const resetTimer = () => {
    if (!logoutInProgress.current) {
      updateActivity();
    }
  };

  useEffect(() => {
    const events = ["mousemove", "click", "keydown", "scroll"];

    if (!localStorage.getItem(activityKey)) {
      updateActivity();
    }

    events.forEach((event) => {
      window.addEventListener(event, resetTimer);
    });

    const interval = setInterval(() => {
      checkInactivity();
    }, 1000);

    const handleStorageChange = (event) => {
      if (event.key === activityKey) {
        checkInactivity();
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      clearInterval(interval);

      events.forEach((event) => {
        window.removeEventListener(event, resetTimer);
      });

      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return <>{children}</>;
};

export default InactivityHandler;